import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CountUp from 'react-countup';
import svg_mutlumusteri from '../assets/img/svg/ico_guven_mobilassistance.svg'
import svg_hizmet from '../assets/img/svg/svg_hizmet.svg'
import svg_hizmetnoktasi from '../assets/img/svg/svg_hizmetnoktasi.svg'
import svg_harita from '../assets/img/svg/svg_harita.svg'
import {
    fetchStats,
    selectStats,
    selectStatsLoading,
    selectStatsError
} from '../store/slices/statsSlice';

export default function Tanitim() {
    const dispatch = useDispatch();
    const data = useSelector(selectStats);
    const loading = useSelector(selectStatsLoading);
    const error = useSelector(selectStatsError);

    useEffect(() => {
        dispatch(fetchStats());
    }, [dispatch]);

    const getSubtitle = (title) => {
        switch (title) {
            case 'Mutlu Müşteri':
            case 'Hizmet':
            case 'Hizmet Noktası':
            case 'İlde':
            default:
                return '';
        }
    };

    const statsCards = [
        {
            icon: svg_mutlumusteri,
            title: 'Mutlu Müşteri',
            value: data?.data?.sales || 0,
            color: 'linear-gradient(135deg, #ff7e00 0%, #f9b224 100%)',
            iconBg: 'linear-gradient(135deg, #ff7e00 0%, #f9b224 100%)',
            delay: 400
        },
        {
            icon: svg_hizmet,
            title: 'Hizmet',
            value: data?.data?.service || 0,
            color: 'linear-gradient(135deg, #0083BF 0%, #052B49 100%)',
            iconBg: 'linear-gradient(135deg, #0083BF 0%, #052B49 100%)',
            delay: 600
        },
        {
            icon: svg_hizmetnoktasi,
            title: 'Hizmet Noktası',
            value: data?.data?.supplier || 0,
            color: 'linear-gradient(135deg, #3D271A 0%, #6B4423 100%)',
            iconBg: 'linear-gradient(135deg, #3D271A 0%, #6B4423 100%)',
            delay: 800
        },
        {
            icon: svg_harita,
            title: 'İlde',
            value: data?.data?.city || 0,
            color: 'linear-gradient(135deg, #80909C 0%, #A1BCD1 100%)',
            iconBg: 'linear-gradient(135deg, #80909C 0%, #A1BCD1 100%)',
            delay: 1000
        }
    ];

    return (
        <>
            <section id="c-know-us" className="standard-section">
                <div className="standard-container">
                    <div className="standard-section-title">
                        <div className="standard-section-title__sub-title" data-aos="fade-up" data-aos-delay="200">
                            VERİLERLE MOBİL ASSİSTANCE
                        </div>
                        <div className="standard-section-title__main" data-aos="fade-up" data-aos-delay="400">
                            <p className="standard-section-title__main--desc">
                                Mobil Assistance, güven, özen ve empati temelinde şekillenen, güçlü teknolojik altyapı ile desteklenen hizmetleriyle sektörde öncü assistans hizmetleri sunar.
                            </p>
                        </div>
                    </div>

                    <div className="c-know-us__item-container">
                        {loading && (
                            <div className="text-center p-5">
                                <div className="modern-spinner">
                                    <div className="spinner-ring"></div>
                                    <div className="spinner-text">İstatistikler Yükleniyor...</div>
                                </div>
                            </div>
                        )}

                        {error && (
                            <div className="error-container text-center p-4" data-aos="fade-up">
                                <div className="error-icon">⚠️</div>
                                <h4 className="error-title">Veri Yüklenemedi</h4>
                                <p className="error-message">{error}</p>
                                <button
                                    className="retry-button"
                                    onClick={() => dispatch(fetchStats())}
                                >
                                    <span className="retry-icon">🔄</span>
                                    Tekrar Dene
                                </button>
                            </div>
                        )}

                        {data && !loading && !error && (
                            <div className="row g-4">
                                {statsCards.map((card, index) => (
                                    <div
                                        key={index}
                                        className="col-lg-3 col-md-6"
                                        data-aos="fade-up"
                                        data-aos-delay={card.delay}
                                    >
                                        <div className="elegant-stats-card">
                                            <div className="elegant-stats-card__header">
                                                <div className="elegant-stats-card__icon" style={{ background: card.iconBg }}>
                                                    <img
                                                        src={card.icon}
                                                        alt={card.title}
                                                        className="elegant-icon-image"
                                                    />
                                                </div>
                                                <div className="elegant-stats-card__decoration-line"></div>
                                            </div>
                                            <div className="elegant-stats-card__body">
                                                <div className="elegant-stats-card__number">
                                                    <CountUp
                                                        separator='.'
                                                        start={0}
                                                        end={card.value}
                                                        duration={2.5}
                                                        delay={0.5}
                                                    />
                                                </div>
                                                <div className="elegant-stats-card__title">{card.title}</div>
                                                <div className="elegant-stats-card__subtitle">
                                                    {getSubtitle(card.title)}
                                                </div>
                                            </div>
                                            <div className="elegant-stats-card__footer">
                                                <div className="elegant-stats-card__progress-bar">
                                                    <div className="elegant-stats-card__progress-fill" style={{ width: `100%` }}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="c-know-us__actions text-center mt-5" data-aos="fade-up" data-aos-delay="1200">
                        <a className="modern-cta-button" href="/tr/kurumsal/mobil-assistance-kurumsal">
                            <span className="button-text">BİZİ TANIYIN</span>
                            <span className="button-arrow">→</span>
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
} 